import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import Datetime from 'react-datetime';
import ReactTable from 'react-table';
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import { get, postWithHeaders, putWithHeadersResponse } from '../../../server/actions';
import moment from 'moment';
import { _addNotification, _addNotificationError, convertTwoDecimalPoint } from '../../../server/util';
import NumericBox from '../../Misc/NumericBox';

const SubscribeType={
    Monthly:'Monthly',
   /*  Quarterly:'Quarterly',
    HalfYearly:'Half Yearly', */
    Yearly:'Yearly'
}
class SubscriptionRec extends Component {
    constructor(props){
        super(props);
        this.state={
            loading:false,
            schools:[],
            schoolInfo:{schoolId:0},
            subscriptionRecords:[],
            rec:{
                id:0,
                onboardedDate: undefined,
                billingStartDate: undefined,
                billingEndDate: undefined,
                subscriptionFee: 0,
                subscriptionType: "",
                billingContactPersonName: "",
                billingContactPersonEmail: "",
            }
        }
    }
    componentWillMount=()=>{
        const {id} = this.context.router.route.match.params;
        this.getSchoolList();
        this.setState({schoolInfo:{schoolId:id} },()=>{
            if(id>0){
                this.getSubscriptionDetails(id);
            }
        });
    }
    componentDidMount=()=> {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getSubscriptionDetails=(id)=>{
        get(`/schoolSubscriptions/search/findByMealSchoolSchoolId?mealSchoolId=${id}&access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                subscriptionRecords: (data._embedded.schoolSubscriptions||[])
            });
        }).catch((error) => {
            console.log('Get SchoolList response', error)
        });

    }
    validBillingStart = ( current )=>{
        const {rec}=this.state;
        if(!moment(rec.onboardedDate,'YYYY-MM-DD').isValid()){
            return false;
        }
        return moment(current).format('YYYYMMDD')>=moment(rec.onboardedDate,'YYYY-MM-DD').format('YYYYMMDD');
    };
    getSchoolList = () => {
        get('/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                schools: (data._embedded.mealSchools||[]).map(rec=>{
                    const sid = rec._links.self.href.split('/').pop();
                    rec.schoolId=sid;
                    return rec;
                })
            });
        }).catch((error) => {
            console.log('Get SchoolList response', error)
        });
    }
    onEdit=(rec)=>{
        let id=rec._links.self.href.split('/').pop();
        id=parseInt(id);
        this.setState({rec:{...rec, id:id||0}});
    }
    onCancelRec=()=>{
        this.setState({rec:{
            id:0,
            onboardedDate: undefined,
            billingStartDate: undefined,
            billingEndDate: undefined,
            subscriptionFee: 0,
            subscriptionType: "",
            billingContactPersonName: "",
            billingContactPersonEmail: "",
        }});
    }
    saveSubscription=()=>{
        const { rec, schoolInfo}=this.state;

        if((schoolInfo.schoolId||0)<=0){
            _addNotificationError('Please select school', this);
            return false;
        }
        if(!rec.onboardedDate){
            _addNotificationError('Please select onboarded date', this);
            return false;
        }
        if(!rec.billingStartDate){
            _addNotificationError('Please select billing start date', this);
            return false;
        }
        if((rec.subscriptionType||'').length<=0){
            _addNotificationError('Please select subscription type', this);
            return false;
        }
        if(!rec.billingEndDate){
            _addNotificationError('Please select billing end date', this);
            return false;
        }
        if(parseFloat(convertTwoDecimalPoint(rec.subscriptionFee||0.00))<=0){
            _addNotificationError('Please enter subscription fee', this);
            return false;
        }
        if((rec.billingContactPersonName||'').length<=0){
            _addNotificationError('Please enter billing contact person name', this);
            return false;
        }
        if((rec.billingContactPersonName||'').length<=0){
            _addNotificationError('Please enter billing contact person name', this);
            return false;
        }
              


        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        if((rec.id||0)<=0){  
            this.setState({loading: true});
            const reqBody={
                ...rec,
                "onboardedDate":moment(rec.onboardedDate).format('YYYY-MM-DD'),
                "billingStartDate":moment(rec.billingStartDate).format('YYYY-MM-DD'),
                billingEndDate:moment(rec.billingEndDate).format('YYYY-MM-DD'),
            }; 
            postWithHeaders(`/mealSchool/${schoolInfo.schoolId}/subscriptions?access_token=`, JSON.stringify(reqBody), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            }).then(data => {
                console.log(data);
                _addNotification('Subscription added successfully.', this);
                this.setState({loading: false});
                this.getSubscriptionDetails(schoolInfo.schoolId);
                this.onCancelRec();
            })
            .catch(
                    (error) => {
                        this.setState({loading: false});
                        _addNotificationError(error, this);
                    }
                );

        }else{
            this.setState({loading: true});
           const reqBody={
                ...rec,
                "onboardedDate":moment(rec.onboardedDate).format('YYYY-MM-DD'),
                "billingStartDate":moment(rec.billingStartDate).format('YYYY-MM-DD')
            };
           putWithHeadersResponse(`mealSchool/${schoolInfo.schoolId}/subscriptions/${rec.id}?access_token=`, JSON.stringify(reqBody), headers).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
            _addNotification('Subscription record updated successfully.', this);
            this.setState({loading: false});
            this.getSubscriptionDetails(schoolInfo.schoolId);  
            this.onCancelRec();         
        })
        .catch(
                (error) => {
                    this.setState({loading: false});
                    _addNotificationError(error, this);
                }
            );
        }
    }
    getTableColumns=()=>{
        let cols=[
              {
                Header: 'Subscription Type',
                accessor: 'subscriptionType',
                width: 150            
            },           
            {
                Header: 'Billing Start Date',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{moment(item.billingStartDate,'YYYY-MM-DD').isValid()? moment(item.billingStartDate,'YYYY-MM-DD').format('MM-DD-YYYY'):null }</span>
                },
                width: 150
            },
            {
                Header: 'Billing End Date',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{moment(item.billingEndDate,'YYYY-MM-DD').isValid()?moment(item.billingEndDate,'YYYY-MM-DD').format('MM-DD-YYYY'):null }</span>
                },
                width: 150
            },
            {
                Header:'Charges',
                Cell:({row})=>{
                    const item=row._original;
                    return <span>{ convertTwoDecimalPoint(item.subscriptionFee||0.00) }</span>
                },
                width: 150
            },
            {
                Header:'ACTION',
                width: 100,
                Cell:({row})=>{
                    return <Fragment>
                        <a href="javascript:void(0);" style={{cursor:'pointer'}} className="edit-btn"
                        onClick={()=>{this.onEdit(row._original)}}>
                        <i className="fa fa-pencil tbl-rounded-icon bg-color-1 fa-icon"/></a>
                        
                        <a href="javascript:void(0);"  className="delete-btn" style={{display:'none',cursor:'pointer'}} onClick={() => this.openModal()}>
                        <i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon"/></a>
                    </Fragment>
                }
            }
        ];
        return cols;
    }
    setBillingEndDate=({startDate,type})=>{
        const {rec}=this.state;
        if(moment(startDate).isValid() && (type||'').length>0){
            if(type==SubscribeType.Monthly){
                rec.billingEndDate=moment(startDate).add('d',30);
            }else if(type==SubscribeType.Quarterly){
                rec.billingEndDate=moment(startDate).add('d',90);
            }else if(type==SubscribeType.HalfYearly){
                rec.billingEndDate=moment(startDate).add('d',180);
            }else if(type==SubscribeType.Yearly){
                rec.billingEndDate=moment(startDate).add('d',360);
            }else{
                rec.billingEndDate=undefined;                
            }
            this.setState({rec:{...rec}});
        }else{
            rec.billingEndDate=undefined; 
            this.setState({rec:{...rec}});
        }
    }
    render() {
        const {loading, rec, schools, schoolInfo, subscriptionRecords}=this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <section className=" full-width clearfix">
                    <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={loading}
                        />
                    </div>
                    <div className="container-full">
                        <div className="sectionTitle">
                            <h2>
                                <span>Add/Edit Subscription</span>
                            </h2>
                        </div>                        
                        <div className="row">
                            <div className='col-md-12'>
                                <div className="clearfix"></div>
                                <div className="panel panel-primary">
                                    <div className="panel-body">
                                        <div className='row'>
                                            <div className='col-md-offset-3 col-md-6 col-sm-12'>
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <div className="form-group">
                                                            <label htmlFor="schoolId">School Name* :</label>
                                                            <select className='form-control' name="schoolId" value={schoolInfo.schoolId} onChange={(e)=>{
                                                                if(schoolInfo.schoolId<=0){
                                                                    const {schoolInfo}=this.state;
                                                                    schoolInfo.schoolId=e.target.value;
                                                                    this.setState({schoolInfo:{...schoolInfo}});
                                                                }
                                                            }}>
                                                                <option></option>
                                                                {
                                                                    schools.map((rec,i)=>{
                                                                        return <option key={i} value={rec.schoolId}>{rec.schoolName}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>

                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="form-group">
                                                            <label htmlFor="onboardedDate">Onboarded Date* :</label>
                                                            <Datetime
                                                                dateFormat={'MM-DD-YYYY'}
                                                                timeFormat={false} closeOnSelect="true"
                                                                value={moment(rec.onboardedDate,'YYYY-MM-DD').isValid()?moment(rec.onboardedDate,'YYYY-MM-DD').toDate():undefined } 
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.onboardedDate=e;
                                                                    this.setState({rec:{...rec}});
                                                                }} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="billingStartDate">Billing Start Date* :</label>
                                                            <Datetime isValidDate={this.validBillingStart}
                                                                dateFormat={'MM-DD-YYYY'}
                                                                timeFormat={false} closeOnSelect="true"
                                                                value={moment(rec.billingStartDate,'YYYY-MM-DD').isValid()?moment(rec.billingStartDate,'YYYY-MM-DD').toDate():undefined}
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.billingStartDate=e;
                                                                    this.setState({rec:{...rec}},()=>{
                                                                        const {rec}=this.state;
                                                                        this.setBillingEndDate({startDate:rec.billingStartDate, type:rec.subscriptionType});
                                                                    });
                                                                }}
                                                                 />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="subscriptionType">Subscription Type* :</label>
                                                            <select className='form-control' name="subscriptionType" value={rec.subscriptionType||''} onChange={(e)=>{
                                                                 const {rec}=this.state;
                                                                 rec.subscriptionType=e.target.value;
                                                                 this.setState({rec:{...rec}},()=>{
                                                                    const {rec}=this.state;
                                                                    this.setBillingEndDate({startDate:rec.billingStartDate, type:rec.subscriptionType});
                                                                });
                                                            }}>
                                                                <option></option>
                                                                {
                                                                    Object.keys(SubscribeType).map(key=>{
                                                                        return <option value={SubscribeType[key]} >{SubscribeType[key]}</option>
                                                                    })
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="billingEndDate">Billing End Date* :</label>
                                                            <Datetime
                                                                dateFormat={'MM-DD-YYYY'}
                                                                timeFormat={false} closeOnSelect="true"
                                                                value={moment(rec.billingEndDate,'YYYY-MM-DD').isValid()?moment(rec.billingEndDate,'YYYY-MM-DD').toDate():undefined} 
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.billingEndDate=e;
                                                                    this.setState({rec:{...rec}});
                                                                }}
                                                                />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="subscriptionFee">Subscription Fee*:</label>
                                                            <NumericBox
                                                                value={rec.subscriptionFee} 
                                                                type="text" className="form-control" maxLength="6"
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.subscriptionFee=e.target.value;
                                                                    this.setState({rec:{...rec}});
                                                                }}
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="billingContactPersonName">Billing Contact Person*:</label>
                                                            <input
                                                                value={rec.billingContactPersonName} 
                                                                type="text" className="form-control"
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.billingContactPersonName=e.target.value;
                                                                    this.setState({rec:{...rec}});
                                                                }}
                                                                />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-4'>
                                                        <div className="form-group">
                                                            <label htmlFor="billingContactPersonEmail">Email Id*:</label>
                                                            <input
                                                                value={rec.billingContactPersonEmail} 
                                                                type="email" className="form-control"
                                                                onChange={(e)=>{
                                                                    const {rec}=this.state;
                                                                    rec.billingContactPersonEmail=e.target.value;
                                                                    this.setState({rec:{...rec}});
                                                                }}
                                                                />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-md-12 text-right'>
                                                        <button className='btn btn-danger btn-sm' onClick={(e)=>{
                                                            this.onCancelRec();
                                                           // this.context.router.history.push('/superAdmin/subscription/');
                                                        }}>Cancel</button>
                                                        <button className='btn btn-success btn-sm' onClick={(e)=>{
                                                            this.saveSubscription();
                                                        }}>Save</button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row form-group'>
                                            <div className='col-md-12'>
                                                <ReactTable
                                                    data={subscriptionRecords||[]}
                                                    columns={this.getTableColumns()}
                                                    defaultPageSize={10}
                                                    className="-striped -highlight"
                                                    noDataText='No data found'
                                                    sortable={true}
                                                    defaultSorting={[{
                                                        id: 'session',
                                                        desc: false
                                                    }]} 
                                                    minRows = {1} />
                                            </div>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>                
            </div>
        );
    }
}
SubscriptionRec.contextTypes = {
    router: PropTypes.object.isRequired
}
export default SubscriptionRec;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Subscription/subscriptionRec.js